<template>
  <div class="checkbox-label-wrapper">
    <span class="icon-postfach icon-checkbox"></span><span class="text">per Brief</span>
  </div>
</template>

<script setup lang="ts"></script>
<style lang="scss" scoped>
.icon-checkbox {
  font-size: 27px !important;
}

.checkbox-label-wrapper {
  display: table;
  margin-top: -4px;
  padding-top: 2px;
}

.checkbox-label-wrapper span {
  display: table-cell;
  vertical-align: middle;
}

.checkbox-label-wrapper span.text {
  padding-left: 9px;
  font-size: 16px !important;
}
</style>
